"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _Instructions = _interopRequireDefault(require("./components/Instructions"));
var _Results = _interopRequireDefault(require("./components/Results"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var BulkUploaders = window.cccisd && window.cccisd.appDefs && window.cccisd.appDefs.bulkUpload;

/** JS part of Bulk Upload */
var BulkUploader = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(BulkUploader, _React$Component);
  function BulkUploader(props, context) {
    var _this;
    _classCallCheck(this, BulkUploader);
    _this = _callSuper(this, BulkUploader, [props, context]);
    _defineProperty(_assertThisInitialized(_this), "getDefinition", function () {
      var stateDef = _this.state.definition;
      if (stateDef && Object.keys(stateDef).length) {
        return stateDef;
      }
      var propsDef = _this.props.definition;
      if (propsDef && Object.keys(propsDef).length) {
        return propsDef;
      }
      if (BulkUploaders && _typeof(BulkUploaders) === 'object' && BulkUploaders[_this.props.handle]) {
        return BulkUploaders[_this.props.handle];
      }
      return {};
    });
    _defineProperty(_assertThisInitialized(_this), "getColumns", function () {
      var def = _this.getDefinition();
      var allColumns = def.columns || [];
      var staticColumnsFrontEndDefaults = def.staticColumnsFrontEndDefaults || {};
      var staticColumnHandles = function () {
        var staticColumnsFromProps = _this.props.staticColumns ? Object.keys(_this.props.staticColumns) : [];
        var staticColumnsFromBuDef = staticColumnsFrontEndDefaults ? Object.keys(staticColumnsFrontEndDefaults) : [];
        return [].concat(_toConsumableArray(staticColumnsFromProps), _toConsumableArray(staticColumnsFromBuDef));
      }();
      return allColumns.filter(function (c) {
        return !staticColumnHandles.includes(c.name);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getTrigger", function () {
      if (_this.props.trigger) {
        return _this.props.trigger;
      }
      var definition = _this.getDefinition();
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default"
      }, definition.triggerText || 'Bulk Upload');
    });
    _defineProperty(_assertThisInitialized(_this), "getModalTitle", function () {
      if (_this.props.modalTitle) {
        return _this.props.modalTitle;
      }
      var definition = _this.getDefinition();
      if (definition.modalTitle) {
        return definition.modalTitle;
      }
      return 'Bulk Upload';
    });
    _defineProperty(_assertThisInitialized(_this), "getDescription", function () {
      if (_this.props.description) {
        return _this.props.description;
      }
      var definition = _this.getDefinition();
      if (definition.description) {
        return definition.description;
      }
      return 'Provide a CSV file below to begin the process.';
    });
    _defineProperty(_assertThisInitialized(_this), "beforeShow", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var def, definition;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            def = _this.getDefinition();
            if (!(def && Object.keys(def).length)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            if (!_this.props.loadDefinition) {
              _context.next = 8;
              break;
            }
            _context.next = 6;
            return _this.props.loadDefinition();
          case 6:
            definition = _context.sent;
            _this.setState({
              definition: definition
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    /**
     * Save the accepted file and mappings to the state, update view to
     * preflightProcessing, then trigger preflight check.
     * @param {File} acceptedFile The user-provided file
     * @param {Object} mapping Keys are bulk upload column names, values are
     *     0-indexed csv column
     */
    _defineProperty(_assertThisInitialized(_this), "acceptValidatedFile", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(acceptedFile, mapping) {
        var _this$props, deploymentId, handle, staticColumns, config, data, response, results;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                file: acceptedFile,
                mappedColumns: mapping
              });
              _this$props = _this.props, deploymentId = _this$props.deploymentId, handle = _this$props.handle;
              staticColumns = _this._getStaticColumnValues();
              config = {
                headers: {
                  'Content-Type': undefined
                }
              };
              data = new FormData();
              data.append('file', acceptedFile);
              data.append('handle', handle);
              data.append('mapping', JSON.stringify(mapping));
              if (deploymentId) {
                data.append('deploymentId', deploymentId);
              }
              if (staticColumns) {
                data.append('staticColumns', JSON.stringify(staticColumns));
              }
              // Submit file to back end for preflight analysis
              _context2.prev = 10;
              _context2.next = 13;
              return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.bulkupload.preflight'), data, config);
            case 13:
              response = _context2.sent;
              if (response.data) {
                results = response.data;
                _this.setState({
                  currentView: 'preflightComplete',
                  results: results
                });
              }
              _context2.next = 20;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](10);
              console.error(_context2.t0);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[10, 17]]);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    /**
     * Clear the file, mapping, and results and re-display the
     * instructions.
     */
    _defineProperty(_assertThisInitialized(_this), "clearValidatedFile", function () {
      _this.setState({
        currentView: 'instructions',
        file: undefined,
        mappedColumns: {},
        results: {}
      });
    });
    /**
     * Send the successfully preflighted file for execution.
     */
    _defineProperty(_assertThisInitialized(_this), "runExecute", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _this$props2, deploymentId, handle, loadData, _this$state, file, isSubmitting, mappedColumns, staticColumns, config, data, response, results;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _this$props2 = _this.props, deploymentId = _this$props2.deploymentId, handle = _this$props2.handle, loadData = _this$props2.loadData;
            _this$state = _this.state, file = _this$state.file, isSubmitting = _this$state.isSubmitting, mappedColumns = _this$state.mappedColumns;
            staticColumns = _this._getStaticColumnValues();
            if (!isSubmitting) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return");
          case 5:
            _this.setState({
              isSubmitting: true
            });
            config = {
              headers: {
                'Content-Type': undefined
              }
            };
            data = new FormData();
            data.append('file', file);
            data.append('handle', handle);
            data.append('mapping', JSON.stringify(mappedColumns));
            if (deploymentId) {
              data.append('deploymentId', deploymentId);
            }
            if (staticColumns) {
              data.append('staticColumns', JSON.stringify(staticColumns));
            }
            // Submit file to back end for preflight analysis
            _context3.prev = 13;
            _context3.next = 16;
            return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.bulkupload.execute'), data, config);
          case 16:
            response = _context3.sent;
            if (response.data) {
              results = response.data;
              _this.setState({
                currentView: 'executeComplete',
                isSubmitting: false,
                results: results
              });
              if (loadData) {
                loadData();
              }
            }
            _context3.next = 24;
            break;
          case 20:
            _context3.prev = 20;
            _context3.t0 = _context3["catch"](13);
            console.error(_context3.t0);
            _this.setState({
              isSubmitting: true
            });
          case 24:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[13, 20]]);
    })));
    /**
     * Decide which component to display.
     * @return {Object} The component to render
     */
    _defineProperty(_assertThisInitialized(_this), "_getCurrentViewContent", function () {
      var _this$state2 = _this.state,
        currentView = _this$state2.currentView,
        results = _this$state2.results;
      var definition = _this.getDefinition();
      var columns = _this.getColumns();
      switch (true) {
        case currentView === 'instructions':
          // `Instructions` has uploader, column descriptions/matching,
          // example csv, and preflight validation button
          return /*#__PURE__*/_react["default"].createElement(_Instructions["default"], {
            acceptValidatedFile: _this.acceptValidatedFile,
            bulkType: definition.bulkType,
            clearValidatedFile: _this.clearValidatedFile,
            columns: columns,
            description: _this.getDescription()
          });
        case currentView === 'preflightComplete':
          // render preflight complete summary
          return /*#__PURE__*/_react["default"].createElement(_Results["default"], {
            clearValidatedFile: _this.clearValidatedFile,
            isPreflight: true,
            results: (results === null || results === void 0 ? void 0 : results.result) || results,
            runExecute: _this.runExecute
          });
        case currentView === 'executeComplete':
          // render summary of completed, executed job
          return /*#__PURE__*/_react["default"].createElement(_Results["default"], {
            clearValidatedFile: _this.clearValidatedFile,
            results: (results === null || results === void 0 ? void 0 : results.result) || results
          });
        default:
          return 'The current view is unrecognized, please contact support!';
      }
    });
    /**
     * Collate the staticColumns provided with the staticColumns that have
     * defaults, giving provided staticColumns precedence.
     * @return {Object} key:value dictionary for each static column
     */
    _defineProperty(_assertThisInitialized(_this), "_getStaticColumnValues", function () {
      var isShowWarnings = _this.state.currentView === 'instructions';
      var definition = _this.getDefinition();
      var staticColumnsFrontEndDefaults = definition.staticColumnsFrontEndDefaults || {};
      var staticColumnValues = _this.props.staticColumns || {};
      Object.keys(staticColumnsFrontEndDefaults).forEach(function (columnName) {
        // If static value is defined in both props and definition, use props
        if (columnName in staticColumnValues) {
          return;
        }

        // If value is Object, it should have the key "path" referring to window.cccisd
        // Otherwise, it is primitive and can be used as listed
        var value = staticColumnsFrontEndDefaults[columnName];
        if (value instanceof Object) {
          var path = value.path;
          if (typeof path !== 'string' && isShowWarnings) {
            console.error("Warning: staticColumnsFrontEndDefaults for '".concat(columnName, "' ") + "should be a primitive value or an object containing the string key \"path\"");
          }
          value = (0, _get2["default"])(window.cccisd, path, null);
        }
        staticColumnValues[columnName] = value;
      });
      Object.keys(staticColumnValues).forEach(function (columnName) {
        if ((staticColumnValues[columnName] === null || staticColumnValues[columnName] === undefined) && isShowWarnings) {
          console.error("Warning: value for static column '".concat(columnName, "' is not defined. Check ") + "'staticColumns' prop or 'staticColumnsFrontEndDefaults' in the bulk upload definition");
        }
      });
      return staticColumnValues;
    });
    _this.state = {
      canPreflight: false,
      // eslint-disable-line
      currentView: 'instructions',
      file: undefined,
      isSubmitting: false,
      mappedColumns: {},
      results: {},
      definition: {}
    };
    return _this;
  }
  _createClass(BulkUploader, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.currentView !== nextState.currentView || this.state.results !== nextState.results || this.state.definition !== nextState.definition || nextProps.handle !== this.props.handle || nextProps.definition !== this.props.definition || nextProps.loadDefinition !== this.props.loadDefinition || nextProps.deploymentId !== this.props.deploymentId || nextProps.staticColumns !== this.props.staticColumns || nextProps.trigger !== this.props.trigger || nextProps.modalTitle !== this.props.modalTitle || nextProps.description !== this.props.description;
    }

    /*
     * If the definition-related props change, clear any dynamically loaded definitions
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.definition !== prevProps.definition || this.props.handle !== prevProps.handle || this.props.loadDefinition !== prevProps.loadDefinition) {
        // Being careful to call setState within a conditional to avoid infinite loop
        //
        this.setState({
          definition: {}
        }); /* eslint-disable-line */
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        size: "large",
        title: this.getModalTitle(),
        trigger: this.getTrigger(),
        beforeShow: this.beforeShow,
        beforeShowSpinner: false,
        afterClose: this.props.afterClose
      }, /*#__PURE__*/_react["default"].createElement("div", null, this._getCurrentViewContent()));
    }
  }]);
  return BulkUploader;
}(_react["default"].Component);
_defineProperty(BulkUploader, "propTypes", {
  handle: _propTypes["default"].string.isRequired,
  definition: _propTypes["default"].object,
  loadDefinition: _propTypes["default"].func,
  deploymentId: _propTypes["default"].number,
  staticColumns: _propTypes["default"].object,
  trigger: _propTypes["default"].object,
  loadData: _propTypes["default"].func,
  modalTitle: _propTypes["default"].string,
  description: _propTypes["default"].string,
  afterClose: _propTypes["default"].func
});